

import {  Popconfirm} from "antd";
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import {  DeleteOutlined, CopyOutlined, EditOutlined } from '@ant-design/icons';



export default function DeleteNode({updateNodeData, id, data, editNode}){
    return (
        
    // <div className="delete-node">
    <div className="delete-node">
    <Popconfirm 
    title="Delete this."
    description="Are you sure to delete this?"
    okText="Yes"
    cancelText="No"
    onConfirm={() => updateNodeData(id,{...data, nodeDeleted:true})}
    >
    <DeleteOutlined style={{color:"red"}}/>
    </Popconfirm>
        {editNode != undefined && <EditOutlined onClick={editNode} />}

    {/* <CopyOutlined onClick={() => updateNodeData(id,{...data, duplicateNode:true})} /> */}
    </div>
)
}